<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.workstationConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="fetch()"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <vxe-table ref="table" :data="data" :edit-config="{}" :loading="loading" keep-source>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :edit-render="{name:'VxeSelect',options:operationTypes}" field="operationType" title="business.label.operationType" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch'}" field="entire" title="business.label.entire" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch'}" field="uShape" title="business.label.uShape" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch'}" field="separable" title="business.label.separable" width="60"/>
        <vxe-column :edit-render="orderTypeRender" field="orderType.name" title="business.label.orderType" width="150"/>
        <vxe-column :edit-render="storageRoomRender" field="storageRoom.name" title="business.label.storageRoom"/>
        <vxe-column :edit-render="targetStorageRoomRender" field="targetStorageRoom.name" title="business.label.targetStorageRoom"/>
        <vxe-column :edit-render="addressRender" field="address.addressInfo.detailAddress" title="business.label.address" width="200"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <order-type-modal ref="orderTypeModal" @change="(values,row)=>onInputChange(row,'orderType',values[0])"/>
    <storage-room-modal ref="storageRoomModal" @change="(values,row)=>onInputChange(row,'storageRoom',values[0])"/>
    <storage-room-modal ref="storageRoom2Modal" @change="(values,row)=>onInputChange(row,'targetStorageRoom',values[0])"/>
    <address-modal ref="addressModal" @change="onAddressChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { deleteOne, findAll, saveAll } from '@/api/Api'
import { WorkstationConfig } from '@/api/dto/config/WorkstationConfig'
import { Zone } from '@/api/dto/common/Zone'
import { Address } from '@/api/dto/common/Address'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import AddressModal from '@/views/modal/AddressModal.vue'
import { onInputChange } from '@/utils/util'

export default {
  components: { OrderTypeModal, StorageRoomModal, AddressModal },
  props: {
    operationTypes: { type: Array, default: [] }
  },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      workstation: new Zone(),
      orderTypeRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.$refs.orderTypeModal.open({ available: true }, row),
          clear: ({ row }) => this.onInputChange(row, 'orderType')
        }
      },
      storageRoomRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.$refs.storageRoomModal.open({ available: true, physical: true }, row),
          clear: ({ row }) => this.onInputChange(row, 'storageRoom')
        }
      },
      targetStorageRoomRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.$refs.storageRoom2Modal.open({ available: true, physical: true }, row),
          clear: ({ row }) => this.onInputChange(row, 'targetStorageRoom')
        }
      },
      addressRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.$refs.addressModal.open({}, row),
          clear: ({ row }) => row.address = new Address()
        }
      }
    }
  },
  methods: {
    onInputChange,
    onAddressChange(values, row) {
      row.address = new Address(values[0])
    },
    fetch(zone) {
      this.loading = true
      if (zone) {
        this.workstation = zone
      }
      findAll('workstationConfigFactory', { 'workstation.ids': [this.workstation.id] }).then(res => {
        if (res.success) {
          this.data = res.result.map(item => {
            return new WorkstationConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      const config = new WorkstationConfig()
      config.available = true
      config.workstation = this.workstation
      this.data.push(config)
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.warehouse = this.warehouse
          return item.toJSONObject()
        })
        saveAll('workstationConfigPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.saveSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('workstationConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.deleteSuccess'))
            this.fetch()
          }
        }).finally(() => this.loading = false)
      } else {
        this.data.splice(this.data.indexOf(row), 1)
      }
    }
  }
}
</script>